<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
// 용어해석 - 대운 & 다음페이지로
import { VCol, VRow } from 'vuetify/lib/components/index.mjs';
// components
import KeywordExplanation from './KeywordExplanation.vue';
import SajuDaeun from '@/components/saju-insight/common/SajuDaeun.vue';
import { useAnalysisDataStore } from '@/store/modules/analysisDataStore';

const emit = defineEmits(['updateIndexNo']);

const { daeunCurNum, daeunsData } = storeToRefs(useAnalysisDataStore());

const langMode = ref('CHNKOR');

const nextPage = () => emit('updateIndexNo', 5);
</script>

<template>
  <VRow class="ss-full-height">
    <VCol cols="12" :md="halfCol" class="ss-full-height">
      <div class="summ-card right">
        <section class="summ-body">
          <KeywordExplanation
            chn="大"
            tit="대운"
            subtit="10년 단위로 흐르는 인생의 큰 계절과도 같습니다."
            :desc="[
              '누구에게나 인생의 봄・여름・가을・겨울이 오듯,',
              '사주에서는 <b>10년 단위로 에너지의 흐름이 바뀝니다.</b>',
            ]"
            :bottom="[
              '지금 나는 어떤 계절을 지나고 있을까?',
              '대운은 \'변화의 타이밍\',',
              '즉 삶의 전환점을 알려주는 중요한 힌트가 됩니다.',
            ]"
          />
          <div class="summ-body__deaun">
            <SajuDaeun
              :pr-birth-data="daeunsData"
              :pr-lang-mode="langMode"
              :pr-type="'daeun'"
              :pr-cur-num="daeunCurNum"
            />
          </div>
        </section>
      </div>
    </VCol>
    <VCol cols="12" :md="halfCol" class="ss-full-height">
      <div class="summ-card next">
        <section class="summ__next-page">
          <div class="next-page__txt content_intro_text_desc">
            <span>
              이제, 어렵게 느껴졌던 사주 키워드들이<br />
              조금은 더 편안하고 익숙하게 다가오셨다면?
            </span>
            <span><b>이제 사주팔자의 요약 해석을 만나보세요!</b></span>
          </div>
          <div class="next-page__btn">
            <button class="next-bnt content_intro_button_next" @click="nextPage">
              다음 페이지로 →
            </button>
          </div>
        </section>
      </div>
    </VCol>
  </VRow>
</template>

<style lang="scss" scoped>
// 상위 컨테이너에서 가로 스크롤 방지
.summ-card {
  overflow-x: hidden;
}

.summ-body {
  overflow-x: hidden;
}

// SajuDaeun wrapper - 내부 컴포넌트에 스크롤 스타일 있음
.summ-body__deaun {
  overflow-x: hidden;
  max-width: 100%;
}
</style>
